import React, { useState, useEffect } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import Header from "../layouts/Header";
import Navbar from "../layouts/Navbar";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

function Program() {
    const navigate = useNavigate();
    const [program, setProgram] = useState([]);

    // Fetch data from the server
    const fetchData = async () => {
        try {
            const token = localStorage.getItem("token");
            if (!token) {
                navigate("/");
                return;
            }

            axios.interceptors.request.use(
                (config) => {
                    config.headers.authorization = token;
                    return config;
                },
                (error) => {
                    return Promise.reject(error);
                }
            );

            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/program/readProgram`
            );
            setProgram(response.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    // Handle deletion of a program
    const handleDelete = async (id_program) => {
        Swal.fire({
            title: "Warning",
            text: "Apakah yakin ingin menghapus data ini?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Ya, hapus!",
            cancelButtonText: "Batal",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await axios.delete(
                        `${process.env.REACT_APP_API_URL}/program/deleteProgram/${id_program}`
                    );
                    fetchData();
                    Swal.fire("Dihapus!", "Data berhasil dihapus.", "success");
                } catch (error) {
                    console.error("Error deleting data:", error);
                    Swal.fire("Error!", "Terjadi kesalahan saat menghapus data.", "error");
                }
            }
        });
    };

    // Columns definition for the DataTable
    const columns = [
        {
            name: "No",
            selector: (row, index) => index + 1,
            sortable: false,
            width: "70px",
        },
        {
            name: "Cover Foto",
            selector: (row) => (
                <img
                    src={
                        row.cover_foto.startsWith("http")
                            ? row.cover_foto
                            : `${process.env.REACT_APP_API_URL}/program/uploads/${row.cover_foto}`
                    }
                    alt="Cover"
                    style={{ width: "100px", height: "70px" }}
                />
            ),
            sortable: true,
            width: "150px",
        },
        {
            name: "Title",
            selector: (row) => row.title,
            sortable: true,
            width: "150px",
        },
        {
            name: "Penjelasan",
            selector: (row) => row.penjelasan,
            sortable: true,
            width: "300px",
        },
        {
            name: "Foto Slider 1",
            selector: (row) => (
                <img
                    src={
                        row.foto_slider.startsWith("http")
                            ? row.foto_slider
                            : `${process.env.REACT_APP_API_URL}/program/uploads/${row.foto_slider}`
                    }
                    alt="Slider"
                    style={{ width: "100px", height: "70px" }}
                />
            ),
            sortable: true,
            width: "150px",
        },
        {
            name: "Foto Slider 2",
            selector: (row) => (
                <img
                    src={
                        row.foto_slider2.startsWith("http")
                            ? row.foto_slider2
                            : `${process.env.REACT_APP_API_URL}/program/uploads/${row.foto_slider2}`
                    }
                    alt="Slider 2"
                    style={{ width: "100px", height: "70px" }}
                />
            ),
            sortable: true,
            width: "150px",
        },
        {
            name: "Foto Slider 3",
            selector: (row) => (
                <img
                    src={
                        row.foto_slider3.startsWith("http")
                            ? row.foto_slider3
                            : `${process.env.REACT_APP_API_URL}/program/uploads/${row.foto_slider3}`
                    }
                    alt="Slider 3"
                    style={{ width: "100px", height: "70px" }}
                />
            ),
            sortable: true,
            width: "150px",
        },
        {
            name: "Foto Slider 4",
            selector: (row) => (
                <img
                    src={
                        row.foto_slider4.startsWith("http")
                            ? row.foto_slider4
                            : `${process.env.REACT_APP_API_URL}/program/uploads/${row.foto_slider4}`
                    }
                    alt="Slider 4"
                    style={{ width: "100px", height: "70px" }}
                />
            ),
            sortable: true,
            width: "150px",
        },
        {
            name: "Foto Slider 5",
            selector: (row) => (
                <img
                    src={
                        row.foto_slider5.startsWith("http")
                            ? row.foto_slider5
                            : `${process.env.REACT_APP_API_URL}/program/uploads/${row.foto_slider5}`
                    }
                    alt="Slider 5"
                    style={{ width: "100px", height: "70px" }}
                />
            ),
            sortable: true,
            width: "150px",
        },
        {
            name: "Foto Slider 6",
            selector: (row) => (
                <img
                    src={
                        row.foto_slider6.startsWith("http")
                            ? row.foto_slider6
                            : `${process.env.REACT_APP_API_URL}/program/uploads/${row.foto_slider6}`
                    }
                    alt="Slider 6"
                    style={{ width: "100px", height: "70px" }}
                />
            ),
            sortable: true,
            width: "150px",
        },
        {
            name: "Aksi",
            cell: (row) => (
                <>
                    <Link to={`/programEdit/${row.id_program}`} className="btn btn-warning mr-2">
                        <i className="nav-icon fas fa-edit" />
                    </Link>
                    <button onClick={() => handleDelete(row.id_program)} className="btn btn-danger">
                        <i className="nav-icon fas fa-trash" />
                    </button>
                </>
            ),
            sortable: false,
        },
    ];

    return (
        <div className="wrapper">
            <Header />
            <Navbar />
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1>Administrasi Program</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item text-decoration-none">
                                        <a href="/#">Administrasi</a>
                                    </li>
                                    <li className="breadcrumb-item active">Program</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title">Data Program</h3>
                                    </div>
                                    <div className="card-body">
                                        <Link to="/programAdd" className="btn btn-primary">
                                            <i className="nav-icon fas fa-plus mr-2" />
                                            Add Data
                                        </Link>
                                        <DataTable columns={columns} data={program} pagination />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default Program;
